import httpClient from './httpClient';

export default {
  // Auth
  logout: () => httpClient.get('user/logout'),
  fetchUser: () => httpClient.get('user/get', { cache: false }),
  fetchBusinesses: () => httpClient.get('user/businesses/get', { cache: false }),
  updateUserData: payload => httpClient.put('user/update', payload),
  updateUserRole: payload => httpClient.put('user/update/role', payload),
  getAuth0PasswordResetLink: payload => httpClient.post('password/auth0resetlink', payload, { cache: false }),
};
